import axios from 'axios';
import { store } from '../redux/store';
import Config from '../Config';

class Services {
    static basePath() {
        return process.env.REACT_APP_BACKEND_APP_URL + process.env.REACT_APP_BACKEND_APP_SERVICE_PREFIX;
    }

    static oauthBasePath() {
        return process.env.REACT_APP_ADMIN_BACK_END + process.env.REACT_APP_BACKEND_APP_SERVICE_PREFIX;
    }

    static getBasicToken() {
        return process.env.REACT_APP_BASIC_TOKEN;
    }

    static checkForUnauthorisedAccess(error) {
        // if (error && error.response && error.response.status === 401) {
        //     Auth.resetAuth();
        //     window.location.replace('/#' + Config.URLs.login);
        // }
    }

    static wrapError(error) {
        if (error && error.response && error.response.status) {
            return error;
        } else {
            return {
                response: {
                    code: 500,
                    message:
                        error && error.message
                            ? error.message
                            : 'An error has occurred, please try again later.'
                }
            };
        }
    }

    // static checkForAccessTokenOrGenerate() {
    //     return new Promise((resolve, reject) => {
    //         HCNLocalData.load(Config.LOCAL_DATA_KEYS.ACCESS_TOKEN).then(
    //             access_token => {
    //                 if (!access_token) {
    //                     axios
    //                         .post(
    //                             Config.getAuthBasePath() + '/oauth/token',
    //                             {
    //                                 grant_type: 'client_credentials',
    //                             },
    //                             {
    //                                 headers: {
    //                                     'Content-Type': 'application/json',
    //                                 },
    //                                 auth: {
    //                                     username:
    //                                         Config.getAccessTokenUsername(),
    //                                     password:
    //                                         Config.getAccessTokenPassword(),
    //                                 },
    //                             },
    //                         )
    //                         .then(function (response) {
    //                             if ([200, 201].includes(response.status)) {
    //                                 HCNLocalData.save(
    //                                     Config.LOCAL_DATA_KEYS.ACCESS_TOKEN,
    //                                     response.data.access_token,
    //                                 );
    //                                 resolve(response.data.access_token);
    //                             } else {
    //                                 reject(response.data);
    //                             }
    //                         })
    //                         .catch(function (error) {
    //                             console.log(error);
    //                         });
    //                 } else {
    //                     resolve(access_token);
    //                 }
    //             },
    //         );
    //     });
    // }

    static async getDefaultHeaders(useBasicAuth = false) {
        let token = store.getState().Reducer.token;

        // Extract access_token if token is an object
        let accessToken = token && typeof token === 'object' && token.access_token ? token.access_token : token;

        // If we don't have a token yet and this is not a Basic Auth flow, fetch it
        if (!accessToken && !useBasicAuth) {
            try {
                await Services.ensureAccessToken();
                token = store.getState().Reducer.token;
                accessToken = token && typeof token === 'object' && token.access_token ? token.access_token : token;
            } catch (e) {
                console.log('Failed to ensure access token', e);
            }
        }

        if (accessToken) {
            return {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            };
        } else {
            return {
                'Content-Type': 'application/json'
            };
        }
    }

    static async getApi(apiUrl) {
        let headers = await Services.getDefaultHeaders();

        return new Promise((resolve, reject) => {
            axios
                .get(apiUrl, {
                    headers: headers
                })
                .then(function (response) {
                    if (
                        response.data.error === false &&
                        [200, 201].includes(response.data.code)
                    ) {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.message);
                    }
                })
                .catch(function (error) {
                    Services.checkForUnauthorisedAccess(error);
                    reject(
                        Services.wrapError(error).response.data
                            ? Services.wrapError(error).response.data.message
                            : Services.wrapError(error).response.message
                    );
                });
        });
    }

    static async ensureAccessToken() {
        const apiUrl = Services.oauthBasePath() + '/' + process.env.REACT_APP_API_VERSION + '/oauth/token';
        const data = 'grant_type=client_credentials';

        // Reuse the OAuth call helper; it already sets Basic + form headers
        const tokenResponse = await Services.postApiWithBasicAuth(apiUrl, data);

        // Store entire token response (works whether reducer expects object or string)
        store.dispatch({
            type: Config.REDUX_REDUCER_TYPES.SET_TOKEN,
            payload: tokenResponse
        });

        return tokenResponse;
    }

    static async postApiWithBasicAuth(apiUrl, data = {}) {
        // Use Basic Auth-specific headers; skip token fetching to avoid recursion
        let headers = await Services.getDefaultHeaders(true);

        // Override with Basic Auth for OAuth
        headers.Authorization = 'Basic ' + Services.getBasicToken();
        headers['Content-Type'] = 'application/x-www-form-urlencoded';

        return new Promise((resolve, reject) => {
            axios
                .post(apiUrl, data, {
                    headers: headers
                })
                .then(function (response) {
                    // OAuth endpoint returns different response structure
                    resolve(response.data);
                })
                .catch(function (error) {
                    Services.checkForUnauthorisedAccess(error);
                    reject(
                        Services.wrapError(error).response.data
                            ? Services.wrapError(error).response.data.message
                            : Services.wrapError(error).response.message
                    );
                });
        });
    }

    static async postApi(apiUrl, data = {}) {
        let headers = await Services.getDefaultHeaders();

        return new Promise((resolve, reject) => {
            axios
                .post(apiUrl, data, {
                    headers: headers
                })
                .then(function (response) {
                    if (
                        response.data.error === false &&
                        [200, 201].includes(response.data.code)
                    ) {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.message);
                    }
                })
                .catch(function (error) {
                    Services.checkForUnauthorisedAccess(error);
                    reject(
                        Services.wrapError(error).response.data
                            ? Services.wrapError(error).response.data.message
                            : Services.wrapError(error).response.message
                    );
                });
        });
    }
}

export default Services;
